import { useCallback, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUserQuestionById } from "../../../api/userQuestion";

export const useUserQuestion = (id: string) => {
    const queryKey = useMemo(() => ["questionId", id], [id]);
    const queryClient = useQueryClient();

    const { data: question, isLoading } = useQuery(queryKey, () =>
        getUserQuestionById(id)
    );

    const clearCache = useCallback(async () => {
        await queryClient.invalidateQueries({ queryKey });
    }, [queryClient, queryKey]);

    return {
        question,
        isLoading,
        clearCache,
    };
};
